import { format, parse } from "date-fns";

/**
 * Parse a Google Analytics dimension date value (`yyyy-MM-dd` or `yyyyMMdd`)
 * into a Date. Returns null if the value isn't a recognised date format
 * or if the parsed date is invalid (e.g. month 13).
 */
export const parseDimensionDate = (value: string): Date | null => {
  const dashFormat = parse(value, "yyyy-MM-dd", new Date());

  if (!isNaN(dashFormat.getTime())) return dashFormat;

  const compactFormat = parse(value, "yyyyMMdd", new Date());

  if (!isNaN(compactFormat.getTime())) return compactFormat;

  return null;
};

export const formatDimensionValue = (
  value: string,
  header: string,
  showYear = true,
) => {
  if (header === "date") {
    const parsedDate = parseDimensionDate(value);

    if (!parsedDate) return value;

    return format(parsedDate, showYear ? "MMM dd, yyyy" : "MMM dd");
  }

  return value;
};
